import Contact from '../../../../common/personnes/components/mini-form/contact/mini.form.contact.model';

export default class CommandeEnteteController {
	static $inject = [
		'$stateParams',
		'$translate',
		'CommandesCommunicationService',
		'CommandesService',
		'notification',
		'OffresService',
		'CentreGestionService',
		'globalizationManagementService',
		'moment'
	];

	constructor(
		$stateParams,
		$translate,
		CommandesCommunicationService,
		CommandesService,
		notification,
		OffresService,
		CentreGestionService,
		globalizationManagementService,
		moment
	) {
		this.$stateParams = $stateParams;
		this.$translate = $translate;
		this.CommandesCommunicationService = CommandesCommunicationService;
		this.CommandesService = CommandesService;
		this.notification = notification;
		this.OffresService = OffresService;
		this.CentreGestionService = CentreGestionService;
		this.listeCommerciaux = [];
		this.contacts = [];
		this.newContact = new Contact();
		this.dateFormat = globalizationManagementService.getCurrentLanguage().dateFormat;
		this.moment = moment;
	}

	async $onInit() {
		this.unregisterReinit = this.CommandesCommunicationService.registerReinit(() => this.initForm());
		this.societes = await this.CommandesService.getSocietes();
		this.types = await this.CommandesService.getCommandeTypes();
		this.modesPaiement = await this.getModesPaiement();
		if (this.commande.entete.clientId) {
			this.loadChantiers();
			this.loadContacts();
		}
		if (this.$stateParams.id) {
			this.setCommandeAsTypeAhead();
		}
		this.isEtatSelected = false;
		this.isEtatAnnulee = false;
		this.isEtatConfirmee = false;
		this.commande.canUpdate = false;

		if (!this.commande.entete.id) {
			this.commande.entete.etat = 0;
		}
		if (this.commande.entete.etat == 0) {
			this.commande.canUpdate = true;
			this.etatText = this.$translate.instant('COMMANDES.ETATS.CONFIRMEE');
			this.isEtatSelected = true;
			this.isEtatConfirmee = true;
		}
		if (this.commande.entete.etat == 1) {
			this.commande.canUpdate = true;
			this.isEtatSelected = true;
		}
		if (this.commande.entete.etat == 2) {
			this.etatText = this.$translate.instant('COMMANDES.ETATS.CLOTUREE');
		}
		if (this.commande.entete.etat == 3) {
			this.isEtatAnnulee = true;
			this.isEtatSelected = true;
		}
		if (this.commande.entete.etat == 4) {
			this.etatText = this.$translate.instant('COMMANDES.ETATS.APLANIFIER');
		}
		if (this.commande.entete.etat == 5) {
			this.etatText = this.$translate.instant('COMMANDES.ETATS.PLANIFIER');
		}
		if (this.commande.entete.societeId != null) {
			this.clients = await this.CommandesService.getClientsCombo(this.commande.entete.societeId, this.siteClient);
		}
		this.etatString = this.commande.entete.etat.toString();

		this.getCodeAuto();
		this.getCommandeDevise();

		if (!this.hasTransport) {
			this.commande.entete.isTransporte = false;
			this.commande.entete.isFranco = false;
		}
	}

	changeEtat() {
		this.commande.entete.etat = parseInt(this.etatString);
	}

	async getCodeAuto() {
		try {
			this.commande.entete.estCodeAuto = await this.CommandesService.estCodeAuto();
			if (this.commande.entete.estCodeAuto) {
				this.commande.entete.afficheCode = await this.CommandesService.afficheCode('commandes');
			} else {
				this.commande.entete.afficheCode = true;
			}
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async loadClients() {
		this.clients = await this.CommandesService.getClientsCombo(this.commande.entete.societeId);
	}

	async reloadClientsOnChange(valeur) {
		if (this.commande.entete.societeId != null) {
			this.clients = await this.CommandesService.getClientsCombo(this.commande.entete.societeId, valeur);
			this.commande.entete.chantierId = null;
		}
		return this.clients;
	}

	async getNomClients(valeur) {
		try {
			const res = await this.CommandesService.getNomClients(valeur);
			return res;
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async loadChantiers() {
		try {
			let id = this.commande.entete.clientId;
			if (this.commande.entete.clientId == 0) {
				id = null;
			}
			this.chantiers = await this.CommandesService.getChantiersCombo(id);
		} catch (err) {
			if (err.data) {
				this.notification.error(err.data);
			} else {
				throw err;
			}
		}
	}

	async setTypeAheadAs(val) {
		if (!this.commande) {
			this.commande = {};
		}
		switch (val) {
			case 'siteClient':
				this.commande.entete.clientId = this.siteClient.id;
				this.commande.entete.nomClient = this.siteClient.libelle;
				await this.loadChantiers();
				await this.loadContacts();
				await this.loadModePaiement();
				break;
			case 'lieu':
				this.commande.entete.lieuId = this.lieu.id;
				this.commande.entete.lieu = this.lieu.libelle;
				this.commande.entete.lieuCode = this.lieu.code;
				break;
		}
	}

	videLieu() {
		this.lieu = {
			id: undefined,
			code: undefined,
			libelle: undefined,
			codeEtLib: ''
		};
		this.commande.entete.lieuId = undefined;
		this.commande.entete.lieu = undefined;
		this.commande.entete.lieuCode = undefined;
	}

	// extraire les dates de Debut et de Fin du chantier sélectionné
	async setChantierDates() {
		this.chantiers.forEach(function (element) {
			if (element.id == this.commande.entete.chantierId) {
				this.commande.entete.dateFinChantier = element.dateFin;
				return;
			}
		}, this);
	}

	changeIsTransporte() {
		if (this.commande.entete.isTransporte == false) {
			this.commande.entete.isFranco = false;
		}
	}

	setCommandeAsTypeAhead() {
		this.siteClient = {
			id: this.commande.entete.clientId,
			libelle: this.commande.entete.nomClient
		};
		this.lieu = {
			id: this.commande.entete.lieuId,
			code: this.commande.entete.lieuCode,
			libelle: this.commande.entete.lieu,
			codeEtLib: this.commande.entete.lieuId ? this.commande.entete.lieu + ' [' + this.commande.entete.lieuCode + ']' : ''
		};
		this.loadCommerciaux(this.commande.entete.societeId);
	}

	$onDestroy() {
		this.unregisterReinit();
	}

	async getLieux(valeur) {
		const lieux = await this.CommandesService.getLieux(valeur);
		return lieux;
	}

	async changeSociete() {
		this.clients = null;
		this.siteClient = null;
		this.commande.entete.chantierId = null;
		this.commande.entete.clientId = null;
		this.getCommandeDevise();
		this.loadSiteCommerciaux();
		this.loadCommerciaux(this.commande.entete.societeId);
	}

	async getCommandeDevise() {
		if (this.commande.entete.societeId) {
			const selectedSociete = await this.CommandesService.getSocieteById(this.commande.entete.societeId);
			if (selectedSociete.paysId) {
				const pays = await this.CommandesService.getPaysById(selectedSociete.paysId);
				this.commande.devise = pays.symboleDevise;
				this.commande.entete.deviseId = pays.deviseId;
			}
		}
	}

	async loadCommerciaux(id) {
		this.listeCommerciaux = await this.OffresService.getPersonnes(id);
	}

	async applyCommentaire() {
		const offre = await this.OffresService.getOffreEnteteById(this.commande.entete.offreId);
		const proposition = offre.propositions.find((prop) => prop.id == this.commande.entete.propositionId);
		const commentaire = [];

		if (offre.commentaire) {
			commentaire.push(`Offre: ${offre.commentaire}`);
		}

		if (proposition && proposition?.commentaire) {
			commentaire.push(`Proposition: ${proposition.commentaire}`);
		}

		this.commande.entete.commentaire = commentaire.join('\n');
	}

	async loadContacts() {
		let id = this.commande.entete.clientId;
		if (this.commande.entete.clientId == 0) {
			id = null;
		}
		try {
			this.contacts = await this.OffresService.getContactsBySite(id);
		} catch (err) {
			console.error(err);
		}
	}
	selectNewContact() {
		this.contacts.push({
			id: this.newContact.id,
			libelle: this.newContact.prenom + ' ' + this.newContact.nom
		});

		this.commande.entete.idContact = this.newContact.id;
	}

	async getModesPaiement() {
		try {
			const modesPaiement = await this.CentreGestionService.getModesPaiement();
			return modesPaiement;
		} catch (err) {
			this.notification.error(err.data);
		}
	}

	async loadModePaiement() {
		this.commande.entete.idModePaiement = null;

		const clientModePaiement = await this.CentreGestionService.getSpecificParameterData(
			'SiteClient',
			this.siteClient.id,
			'FACTU',
			'modePaiement',
			{
				clientId: this.siteClient.id,
				date: this.moment().format(this.dateFormat),
				typeClientId: this.siteClient.typeClientId,
				societeId: this.commande.entete.societeId,
				hasToCheckPont: false
			},
			1
		);

		if (clientModePaiement) {
			this.commande.entete.idModePaiement = parseInt(clientModePaiement);
		}
	}
}
